
import React from 'react'
import ContentLoader from "react-content-loader"
import { memo } from 'react'
import { Fragment } from 'react'

const AddonWithMediaSkeleton = (props) => {
//debugger
    return (



        <Fragment>
            <div class="accordian-wrapper-form">






                <div className="mobile-accordian-event">
                    <ContentLoader
                        height={25}
                        width={'100%'}
                        speed={2}
                        backgroundColor="#f3f3f3"
                        foregroundColor="#ecebeb"
                    >
                        <rect x="0%" y="0%" rx="0" ry="0" width="35%" height="30" />
                    </ContentLoader></div>

                <div class="box-form-wrapper" >


                    <div class="full-width-content">
                        <ContentLoader
                            height={25}
                            width={'100%'}
                            speed={2}
                            backgroundColor="#f3f3f3"
                            foregroundColor="#ecebeb"
                        >
                            <rect x="0%" y="0%" rx="0" ry="0" width="35%" height="30" />
                            <rect x="0%" y="100%" rx="0" ry="0" width="35%" height="30" />
                        </ContentLoader>
                    </div>




                </div>

            </div>
            <div class="video-wrapper"><div class="video">
                <ContentLoader
                    height={`100%`}
                    width={'100%'}
                    speed={2}
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb"
                >
                    <rect x="0%" y="0%" rx="0" ry="0" width="100%" height="100%" />
                </ContentLoader>
            </div></div>

        </Fragment>
    )

}

export default memo(AddonWithMediaSkeleton)